export default __webpack_public_path__ + "static/media/surface-treatment-and-plating.76893f9e.png";